import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect, useRef } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { FaCheck } from "react-icons/fa";
import Footer from "components/Footers/Footer";
import { HashLink } from "react-router-hash-link";
import { useSize } from "components/SizeControl/SizeControl";
import { Accordion, AccordionTab } from "primereact/accordion";
// import imageHeader from "../assets/ossaPictures/teknolojikCihazlarlaDestek/alanlar/AndulasyonHeader.png";
import PictureHeader from "components/PictureHeader/PictureHeader";
import { useNavigate } from "react-router-dom";

const GozdeNazikIcer = () => {
  const { under1200, under992 } = useSize();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    // Sayfa yüklendiğinde .gt-lang-code elementini bul ve değişiklik yap
    const targetLink = document.querySelector('a[data-gt-lang="tr"]'); // Değiştirmeniz gereken class veya id'yi buraya ekleyin

    if (targetLink) {
      // Otomatik tıklama
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png"; // Değiştirmeniz gereken yeni resim yolunu buraya ekleyin
      console.log(imgElement);
      imgElement.src = newImgSrc;
      imgElement.width = "32";
      imgElement.height = "32";
    }
  }, []);
  const headerRef = useRef(null);
  return (
    <>
      <Helmet>
        <title>GÖZDE NAZİK İÇER | OSSA CLINIC</title>
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="OSSA CLINIC" data-rh="true" />
        <link rel="canonical" href="https://www.ossaclinic.com/" />
        <meta property="og:title" content="GÖZDE NAZİK İÇER | OSSA CLINIC" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="OSSA CLINIC" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="https://www.ossaclinic.com/" />
      </Helmet>
      <WhiteNavbar navbarSelection={"about-us"} />
      {/* <PictureHeader imageHeader={imageHeader} /> */}
      <div ref={headerRef}>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div style={{ height: "6rem" }}></div>
          <div>
            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>GÖZDE NAZİK İÇER - UZMAN PSİKOLOJİK DANIŞMAN</b>
            </h2>
          </div>
          <Row>
            <Col className="ml-auto" md="6" style={{ alignContent: "center" }}>
              <img
                alt="..."
                className="img rounded"
                src={require("assets/ossaPictures/GozdeNazikIcer.png")}
              ></img>
            </Col>
            <Col
              className="mr-auto mt-5 mt-md-3"
              md="6"
              data-aos="zoom-in"
              data-aos-duration="2000"
              style={{ alignSelf: "center" }}
            >
              <h3>
                <strong>Kişisel Bilgiler</strong>
              </h3>

              <p>
                2008-2012 yıllarında Ankara Üniversitesi Psikolojik Danışmanlık
                ve Rehberlik Lisans Eğitimini tamamlamıştır.
              </p>
              <p>
                2014-2016 yıllarında Nişantaşı Üniversitesi Psikoloji Yüksek
                Lisans Eğitimini bitirmiştir.
              </p>
              <p>
                Kıbrıs İlim Üniversitesinde Klinik Psikoloji Yüksek Lisans
                eğitimine devam etmektedir.
              </p>

              <br />

              <h3>
                <strong>Uzmanlık Eğitimi</strong>
              </h3>
              <ul>
                <li>
                  Aile Danışmanlığı Uzmanlık Eğitimi (2012-Ankara / 150 saat)
                </li>
                <li>
                  Yaratıcı Drama Eğitmenliği ve Liderliği (2012-2013 / 450 saat)
                </li>
                <li>Doğru Nefes Egzersizleri Eğitimi (2013)</li>
                <li>Psikososyal Müdahale Eğitimi (18 Mart-22 Mart 2013)</li>
                <li>Temel Kabiliyetler Testi Eğitimi (Mayıs 2014)</li>
                <li>Grupla Psikolojik Danışma Eğitimi (21-25 Eylül 2014)</li>
                <li>
                  Kariyer Danışmanlığı Eğitimi / Haliç Üniversitesi (13 Mayıs
                  2014)
                </li>
                <li>
                  Kısa Süreli Çözüm Odaklı Terapi Eğitimi (2015-Klinik Psikolog
                  Dr. Olcay GÜNER-12 Saat)
                </li>
                <li>Eğitim Koçluğu (05.2017 MEB / 30 Saat)</li>
                <li>
                  Terapötik Kartlar Eğitimi (2019-12 Saat Doç. Dr. Durmuş Ümmet)
                </li>
                <li>
                  Psikodrama Grup Psikoterapisi ve Sosyometri Sistemi Eğitimi
                  (Kasım 2018-Haziran 2022- İstanbul Psikodrama Enstitüsü-350
                  saat)
                </li>
                <li>
                  Doğuma Hazırlık Eğitmenliği-Doulalık-Doğum Psikoterapistliği
                  (Ekim 2018-Ocak 2023 132 Saat)
                </li>
                <li>EMDR 1. Düzey (Şubat 2023-Davranış Bilimleri Enstitüsü)</li>
                <li>
                  Çocuk Merkezli Oyun Terapisi (Mart 2023-Mehmet TEBER, Ahenk
                  Psikoloji)
                </li>
                <li>
                  EMDR 2. Düzey (Ağustos 2023-Davranış Bilimleri Enstitüsü)
                </li>
                <li>
                  Attachment Parenting International Ebeveyn Eğitmenliği (Mart
                  2024, API)
                </li>
                <li>
                  SIATT-Bebeklik ve Erken Çocukluk Dönemi Sosyal İletişim Alan
                  Gelişim Tarama Testi ve Gelişim Programı Düzenleme Temel Düzey
                  Kursu (Mayıs 2024, Psk. Dan. Nilcan KULELİ SERTGİL)
                </li>
              </ul>

              <br />

              <h3>
                <strong>Hizmet Alanları</strong>
              </h3>
              <p>
                Ante Sağlıkta Ergen, Yetişkin Terapisi, 0-3 Yaş Ebeveyn
                Danışmanı, Hamile ve Doğum Psikoterapisi alanlarında hizmet
                vermektedir.
              </p>
            </Col>
          </Row>
          <div>
            <div className="title">
              <h2
                className="ml-auto mr-auto text-center"
                style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <b>VİDEO İÇERİKLERİ</b>
              </h2>
            </div>
            <br></br>
            <br></br>

            <Row className="justify-content-center">
              <Col md="6">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/3p6JjqZYavk?si=wQNf_K5LZv_8uHqh"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </Col>
            </Row>
          </div>
          <div className="team-2 pb-0 pt-0">
            <div className="title">
              <br></br>

              <h2
                className="ml-auto mr-auto text-center"
                style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <b>DİĞER UZMANLARIMIZ</b>
              </h2>
            </div>
            <br></br>
            <Row className="justify-content-center">
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/abdullah-okur"
                      style={{ border: "none" }}
                      aria-label="ABDULLAH OKUR"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/AbdullahOkar.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/abdullah-okur"
                        style={{ color: "#123274", borderStyle: "none" }}
                        aria-label="ABDULLAH OKUR"
                      >
                        <b style={{ fontWeight: "bolder" }}>ABDULLAH OKUR</b>
                        <br />
                        <i>Uzman Fizyoterapist</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/ayca-albay"
                      aria-label="Ayça Albay"
                      style={{ border: "none" }}
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/AycaAlbay.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/ayca-albay"
                        style={{ color: "#123274", borderStyle: "none" }}
                        aria-label="Ayça Albay"
                      >
                        <b style={{ fontWeight: "bolder" }}>AYÇA ALBAY</b>
                        <br />
                        <i>Fizyoterapist</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/berkay-bugra-turan"
                      style={{ border: "none" }}
                      aria-label="BERKAY BUĞRA TURAN"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/BerkayBugraTuran.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/berkay-bugra-turan"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="BERKAY BUĞRA TURAN"
                      >
                        <b style={{ fontWeight: "bolder" }}>
                          BERKAY BUĞRA TURAN
                        </b>
                        <br />
                        <i>Fizyoterapist</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/ilkenur-sari"
                      style={{ border: "none" }}
                      aria-label="ilkenur sarı"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/IlkenurSari.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/ilkenur-sari"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="ilkenur sarı"
                      >
                        <b style={{ fontWeight: "bolder" }}>İLKENUR SARI</b>
                        <br />
                        <i>Fizyoterapist</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/ayberk-can-ak"
                      style={{ border: "none" }}
                      aria-label="ayberk can ak"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/AyberkCanAk.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/ayberk-can-ak"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="ayberk can ak"
                      >
                        <b style={{ fontWeight: "bolder" }}>AYBERK CAN AK</b>
                        <br />
                        <i>Fizyoterapist</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/busra-uzuner"
                      style={{ border: "none" }}
                      aria-label="BÜŞRA UZUNER"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/BusraUzuner.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/busra-uzuner"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="BÜŞRA UZUNER"
                      >
                        <b style={{ fontWeight: "bolder" }}>BÜŞRA UZUNER</b>
                        <br />
                        <i>Diyetisyen</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/tugce-sengul-karahanci"
                      style={{ border: "none" }}
                      aria-label="TUĞÇE ŞENGÜL KARAHANCI"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/TugceSengulKarahanci.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/tugce-sengul-karahanci"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="TUĞÇE ŞENGÜL KARAHANCI"
                      >
                        <b style={{ fontWeight: "bolder" }}>
                          TUĞÇE ŞENGÜL KARAHANCI
                        </b>
                        <br />
                        <i>Diyetisyen</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="card-plain card-blog"
                  onClick={() => headerRef.current.scrollIntoView()}
                >
                  <div
                    className="card-image"
                    style={{ textAlign: "-webkit-center" }}
                  >
                    <HashLink
                      to="/hakkimizda/ece-ellialtioglu"
                      style={{ border: "none" }}
                      aria-label="ECE ELLİALTIOĞLU"
                    >
                      <img
                        alt="..."
                        className="img rounded"
                        src={require("assets/ossaPictures/EceEllialtioglu.png")}
                      ></img>
                    </HashLink>
                  </div>
                  <CardBody>
                    <CardTitle
                      tag="h1"
                      className="text-center"
                      style={{ fontSize: "1.4rem", fontWeight: "400" }}
                    >
                      <HashLink
                        to="/hakkimizda/ece-ellialtioglu"
                        style={{ color: "#123274", border: "none" }}
                        aria-label="ECE ELLİALTIOĞLU"
                      >
                        <b style={{ fontWeight: "bolder" }}>ECE ELLİALTIOĞLU</b>
                        <br />
                        <i>Uzman Klinik Psikolog</i>
                      </HashLink>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default GozdeNazikIcer;
